import React, { Component } from "react";
import SkuList from "./SkuList";
import SkuAddEdit from "./SkuAddEdit";

class Sku extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: "List",
      data: null
    };
    this.handleClick = this.handleClick.bind(this);
    //this.handleLogoffClick = this.handleLogoffClick.bind(this);
  }
  render() {
    if (this.state.mode === "List") {
      return <SkuList onClick={this.handleClick} />;
    } else {
      return (
        <SkuAddEdit
          pData={this.state.data}
          onClick={this.handleClick}
          source="list"
        />
      );
    }
  }

  handleClick(mode, data) {
    this.setState({ data });
    //else this.setState({ data: pData });
    this.setState({ mode });
  }
}

export default Sku;
